var render, staticRenderFns
import script from "./PersonSearch.vue?vue&type=script&lang=js"
export * from "./PersonSearch.vue?vue&type=script&lang=js"
import style0 from "./PersonSearch.vue?vue&type=style&index=0&id=334b140a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334b140a",
  null
  
)

export default component.exports